export default __webpack_public_path__ + "static/media/property_537.34cda10e.png";